export default __webpack_public_path__ + "static/media/editor.e97af93c.svg";